import smoothscroll from 'smoothscroll-polyfill';
import { initializeAccordions, configureButtonsForToggling } from './utilities/accordion';
import { initializeImageSlider } from './pdp/slider';
import { scrollToReviewsSmooth } from './pdp/scrollToReviews';
import { initializePricing } from './pdp/pricing';
import { updateBreadcrumbTitle } from './utilities/updateBreadcrumbTitle';
import { initializeSchema } from './pdp/schemaDetails';

(async ({
  featureFlags,
  redirect,
  pricing,
  productTitle,
  hasStoreDetails,
  product,
} = {}) => {
  if (redirect?.target) {
    window.parent.location = redirect.target;
    return;
  }

  if (featureFlags?.full_page) {
    import(
      /* webpackChunkName: "quantities" */
      './pdp/quantity/quantities'
    );
    initializePricing(pricing, hasStoreDetails);
    smoothscroll.polyfill();
    scrollToReviewsSmooth();

    configureButtonsForToggling(
      document.querySelectorAll('.pdp-incentive__button'),
      document.querySelectorAll('.pdp-incentive__content'),
    );
  }

  updateBreadcrumbTitle(productTitle);

  initializeAccordions(
    document.querySelectorAll('.pdp-details .pdp-accordion__button'),
    document.querySelectorAll('.pdp-details .pdp-accordion__content'),
  );

  initializeImageSlider();
  initializeSchema(product, pricing);
})(window.drupalSettings);
